import clsx from 'clsx';
import type { DetailedHTMLProps, Ref, TextareaHTMLAttributes } from 'react';

import s from './inputs.module.scss';

export const TextArea = ({
  label,
  error,
  mandatory,
  className,
  rows = 5,
  suffixNode,
  ref,
  ...props
}: {
  label?: string;
  error?: string;
  mandatory?: boolean;
  /** Node at the right edge of the box, as on `Input` (e.g. a spinner while the field fills). */
  suffixNode?: React.ReactNode;
  ref?: Ref<HTMLTextAreaElement>;
} & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>) => {
  return (
    <label className={clsx(s.InputRoot, className)}>
      {label && (
        <div className={s.Label}>
          <span>{label}</span>
          {mandatory && <span>*</span>}
        </div>
      )}
      <div
        className={clsx(
          s.InputWrapper,
          s.TextAreaWrapper,
          error && s.error,
          suffixNode && s.withSuffixNode,
        )}
      >
        <textarea className="body-medium" {...props} rows={rows} ref={ref} />
        {suffixNode && <span className={s.suffixInteractive}>{suffixNode}</span>}
      </div>
      {!!error && <p className={s.Error}>{error}</p>}
    </label>
  );
};
